import React, { useState } from "react";
import { Hotel } from "../Types/hotelTypes";
import { hotelValues } from "../initialValus";
import { hotelFields } from "../fields";
import {
    useCreateHotelMutation,
    useUpdateHotelMutation,
} from "../Service/hotelsApi";
import { HotelsRoutes } from "../../../Router/path";
import HotelIcon from "@mui/icons-material/Hotel";
import InfoIcon from "@mui/icons-material/Info";
import SearchIcon from "@mui/icons-material/Search";
import SettingsIcon from "@mui/icons-material/Settings";
import ImageIcon from "@mui/icons-material/Image";
import UploadImagesForm from "../Components/UploadImagesForm";
import AccordionCard from "../../Shared/Components/AccordionCard/AccordionCard";

import EntityFormLayout from "../../Shared/Components/EntityFormLayout/EntityFormLayout";
import { Typography } from "@mui/material";
import { FormRenderGroupTypes } from "../../Shared/Components/FormRenderer/FormRenderGroup.types";
import LocationOnIcon from '@mui/icons-material/LocationOn';
import { useEntityForm } from '../../Shared/Hooks/useEntityForm';

const CreateHotel = () => {
    const [createHotel, createStatus] = useCreateHotelMutation();
    const [updateHotel, updateStatus] = useUpdateHotelMutation();
    const [createdHotelId, setCreatedHotelId] = useState<number | null>(null);

    const mutationStatus = createdHotelId ? updateStatus : createStatus;

    const entityForm = useEntityForm<Hotel>({
        initialData: hotelValues,
        fields: hotelFields.filter(f => {
            if (!createdHotelId && f.name === 'slug') return false;
            return true;
        }),
        submitFn: (data) => {
            if (createdHotelId) {
                return updateHotel({ id: createdHotelId, data }).unwrap();
            } else {
                const { id, ...payload } = data;
                return createHotel(payload).unwrap();
            }
        },
        redirectUrl: HotelsRoutes.root,
        title: "Dodaj hotel",
        icon: <HotelIcon />,
        backUrl: HotelsRoutes.root,
        groupOrder: [
            FormRenderGroupTypes.basic,
            FormRenderGroupTypes.address,
            FormRenderGroupTypes.seo,
            FormRenderGroupTypes.configuration,
        ],
        groupIcons: {
            Podstawowe: <InfoIcon sx={{ color: theme => theme.palette.primary.main }} />,
            SEO: <SearchIcon sx={{ color: theme => theme.palette.primary.main }} />,
            Konfiguracja: <SettingsIcon sx={{ color: theme => theme.palette.primary.main }} />,
            Adres: <LocationOnIcon sx={{ color: theme => theme.palette.primary.main }} />,
        },
        showSuccessBeforeRedirect: true,
        redirectDelay: 2000,
        onSuccessWithResponse: (response, shouldRedirect) => {
            if (!shouldRedirect) {
                setCreatedHotelId(response.hotelId.id);
            }
        },
        mutationStatus,
    });

    return (
        <>
            <EntityFormLayout {...entityForm}>
                <AccordionCard title="Zdjęcia" icon={<ImageIcon />}>
                    {createdHotelId ? (
                        <UploadImagesForm hotelId={createdHotelId} />
                    ) : (
                        <Typography color="text.secondary">
                            Zdjęcia możesz dodać dopiero po zapisaniu hotelu.
                        </Typography>
                    )}
                </AccordionCard>
            </EntityFormLayout>
        </>
    );
};

export default CreateHotel;
